import { render, staticRenderFns } from "./KosiwonRegisterConfirm.vue?vue&type=template&id=7c119d0c"
import script from "./KosiwonRegisterConfirm.vue?vue&type=script&lang=js"
export * from "./KosiwonRegisterConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports